import { render, staticRenderFns } from "./TicketInput.vue?vue&type=template&id=870250de&"
import script from "./TicketInput.vue?vue&type=script&lang=ts&"
export * from "./TicketInput.vue?vue&type=script&lang=ts&"
import style0 from "./TicketInput.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports